export enum basegameAssetConfig {
    //betTextBgImage = "assets/basegame/bet.png",
    // balanceTextBgImage = "assets/basegame/balance.png",
    //winTextBgImage = "assets/basegame/win.png",
    //coinBgImage = "assets/basegame/coin.png",
    Bg_frame = "assets/basegame/basegame_reel.png",

    //mobileViewBottomBarImage1 = "assets/basegame/win_bar.png",
    // mobileViewBottomBarImage2 = "assets/basegame/balance_bet_bar.png",
    // buttonPanelLeftBottomBar = "assets/basegame/fg_left_bar.png",
    // buttonPanelRightBottomBar = "assets/basegame/fg_right_bar.png",
    BG_Multiways_num = "assets/font/num-export.xml",

    // rainbowLoop = "assets/basegame/rainbow_loop_in.json",
    partical_explode = "assets/basegame/partical_explode.json",
    bg_bottom_grass = "assets/basegame/bg_bottom_grass.png",
    bg_front_grass = "assets/basegame/bg_front_grass.png",
    header_meter = "assets/basegame/header_meter.png",
    game_logo = "assets/basegame/Logo.json",
    basegameLeave = "assets/basegame/basegame.json",
    skull = "assets/basegame/skull.json",
    skull_meter_fx = "assets/basegame/skull_meter_fx.json",

    total_win_meter_bg = "assets/basegame/total_win_meter_bg.png",
    total_win_text = "assets/basegame/total_win_text.png",
    bodyBuilderCharacter = "assets/basegame/bodybuilder_character.json",
    skeletonCharacter = "assets/basegame/skeleton_character.json",
    bodyBuilderCharacterBtn = "assets/basegame/bodybuilder_btn.png",
    skeletonCharacterBtn = "assets/basegame/skull_btn.png",

    bodyBuilderCharacterBtnMob = "assets/basegame/mobile_bodybuilder_btn.png",
    skeletonCharacterBtnMob = "assets/basegame/mobile_skull_btn.png",
    Particle_01 = "assets/basegame/Particle_01.png",
    //buy_now_icon_updated = "assets/basegame/buy_now_icon.png",
    animChangeEffect = "assets/basegame/skeleton.json",

    btnGlow = "assets/basegame/fx_glow.json",

    //Giant Wild Assets
    Orb_Fx_loop = "assets/giantwild/Orb_Fx_loop.json",
    streak_flash_fx = "assets/giantwild/streak_flash_fx.json",
    scull_glow = "assets/giantwild/scull_glow.png",

    // bonus_buy_assets = "assets/bonus_buy/bonus_buy_assets.json",
    bonus_buy_assets = "assets/bonus_buy/bonus_buy.json",
}